import styles from "./ViewOptions.module.scss";
import React, { useState, useCallback } from "react";
import { TermsAndConditions } from "components/content/dialogAd/steps/publishStep/PublishStep";
import { TagsDropdown } from "components/content/dialogAd/steps/publishStep/TagsDropdown";
import { useConfigs } from "hooks/useConfigs";
import { ApiCategory, ApiTag } from "core/configs/configs.entity";
import CardWrapper from "components/commons/cardWrapper/CardWrapper";
import Footer from "components/commons/footer/Footer";
import { Button, ButtonSize, TextField } from "@bale/ui";
import { useAppDispatch, useAppSelector } from "utils/store";
import { OrderAdActions, OrderAdPages } from "core/orderAd/orderAd.slice";
import { strings } from "intl/fa";
import Modal from "components/commons/modal/Modal";
import { formatStrings } from "utils/utils";
import {
  GeneralErrors,
  GeneralValidators,
  useInputHandler,
} from "hooks/useInputHandler";
import { digitsToHindi, fromMoneyFormats, toMoneyFormat } from "@bale/utils";

// const memberCountSegments: SponsoredMessageOption[] = [
//   { min_channel_members: 0, max_channel_members: 5000 },
//   { min_channel_members: 5000, max_channel_members: 10000 },
//   { min_channel_members: 10000, max_channel_members: 20000 },
//   { min_channel_members: 20000, max_channel_members: -1 },
// ];

enum HelperModals {
  MembersCountHelper = "MembersCountHelper",
  TagsHelper = "TagsHelper",
  PriceHelper = "PriceHelper",
}

const modalMaker = (modal: HelperModals) => {
  if (modal === HelperModals.MembersCountHelper) {
    return {
      title: strings.sponsored_messages.channelMembersTitle,
      body: strings.sponsored_messages.channelMembersModalText,
    };
  }
  if (modal === HelperModals.TagsHelper) {
    return {
      title: strings.sponsored_messages.tagsTitle,
      body: strings.sponsored_messages.tagsModalText,
    };
  }
  if (modal === HelperModals.PriceHelper) {
    return {
      title: strings.sponsored_messages.priceTitle,
      body: "strings.sponsored_messages.priceModalText",
    };
  }
};

interface Props {
  isCampaign?: boolean;
}
const ViewOptions: React.FC<React.PropsWithChildren<Props>> = ({
  isCampaign,
}) => {
  const [termsAccepted, setTermsAccepted] = useState<boolean>(false);
  // const [selectedMemberOption, setSelectedMemberOption] = useState(
  //   memberCountSegments[0]
  // );
  const [selectedTag, setSelectedTag] = useState<ApiTag | undefined>(undefined);
  const [subcategories, setSubcategories] = useState<ApiCategory[] | null>(
    null
  );
  const [selectedSubcategory, setSelectedSubcategory] =
    useState<ApiCategory | null>(null);
  const [showingHelperModal, setShowingHelperModal] = useState<
    false | HelperModals
  >(false);

  const { categories, max_sponsored_message_view, min_sponsored_message_view } =
    useConfigs();
  const { view_count } = useAppSelector((state) => state.orderAd.info);
  const dispatch = useAppDispatch();

  const viewCountInputHandler = useInputHandler({
    rules: [
      GeneralValidators.minAmount(min_sponsored_message_view),
      GeneralValidators.maxAmount(max_sponsored_message_view),
    ],
    errorMessages: {
      [GeneralErrors.MinimumAmount]: formatStrings(
        strings.sponsored_messages.min_sponsored_view_order,
        {
          min: digitsToHindi(toMoneyFormat(String(min_sponsored_message_view))),
        }
      ),
      [GeneralErrors.MaximumAmount]: formatStrings(
        strings.sponsored_messages.max_sponsored_view_order,
        {
          max: digitsToHindi(toMoneyFormat(String(max_sponsored_message_view))),
        }
      ),
    },
    numberOnly: true,
    beforeChange: fromMoneyFormats,
    formatter: toMoneyFormat,
    initialValue: view_count ? String(view_count) : undefined,
  });

  const onCategoryChange = useCallback((tag: ApiTag) => {
    setSelectedTag(tag);
    setSubcategories(tag.Subcategory);
    setSelectedSubcategory(null);
  }, []);

  const onSubcategoryChange = useCallback((subcategory: ApiCategory) => {
    setSelectedSubcategory(subcategory);
  }, []);

  const handleChangeTerms = useCallback(() => {
    setTermsAccepted((prevState: boolean) => !prevState);
  }, []);

  const submitHandler = () => {
    dispatch(
      OrderAdActions.setOrderAdInfo({
        tag_1: selectedTag?.Id,
        tag_2: selectedSubcategory?.Id,
        view_count: +viewCountInputHandler.rawValue,
        // sponsored_message_options: {
        //   min_channel_members: selectedMemberOption.min_channel_members,
        //   max_channel_members: selectedMemberOption.max_channel_members,
        // },
      })
    );
    if (isCampaign) {
      dispatch(
        OrderAdActions.setPage(OrderAdPages.CampaignSponsoredMessagePreview)
      );
    } else {
      dispatch(OrderAdActions.setPage(OrderAdPages.SponsoredMessagePreview));
    }
    // dispatch(OrderAdActions.setPage(OrderAdPages.SponsoredMessageMoreinfo));
  };

  const closeHelperModal = () => {
    setShowingHelperModal(false);
  };

  const modalProperties = {
    ...modalMaker(showingHelperModal || HelperModals.MembersCountHelper),
  };

  const isFormInvalid =
    !selectedTag ||
    (selectedTag.Subcategory && !selectedSubcategory) ||
    !termsAccepted ||
    !!viewCountInputHandler.error ||
    !viewCountInputHandler.rawValue;
  // !selectedMemberOption.max_channel_members;

  return (
    <>
      <CardWrapper className={styles.Card}>
        {/* <ProgressSteps steps={sponsoredMessageSteps} currentStep={2} /> */}
        {/* {showDismissibleHelp && (
          <DismissibleHelp
            helpText={strings.sponsored_messages.price_isnt_fixed}
            onClose={() => setShowDismissibleHelp(false)}
            moreInfo={{
              title: strings.sponsored_messages.more_info,
              onClick: () => setShowingHelperModal(HelperModals.PriceHelper),
            }}
          />
        )} */}
        {/* <div className={styles.SectionHeader}>
          <p className={styles.SectionTitle}>
            {strings.sponsored_messages.channelMembersTitle}
          </p>
          <Info
            size={20}
            color={theme.colors.dark[300]}
            cursor="pointer"
            onClick={() =>
              setShowingHelperModal(HelperModals.MembersCountHelper)
            }
          />
        </div>
        <AdPanelDropdown
          items={memberCountSegments}
          onSelectedItemChange={(selected) =>
            setSelectedMemberOption({
              ...selected,
            })
          }
          itemToString={(item) => sponsoredMessageOptionToText(item)}
          placeholderMessage=""
          selectedItemFormatter={(item) => sponsoredMessageOptionToText(item)}
          defaultSelectedItem={memberCountSegments[0]}
          label={strings.sponsored_messages.membersCount}
        /> */}
        <div className={styles.SectionHeader}>
          <p className={styles.SectionTitle}>
            {strings.sponsored_messages.view_count}
          </p>
        </div>
        <TextField
          {...viewCountInputHandler}
          helpText={
            viewCountInputHandler.error
              ? undefined
              : formatStrings(
                  strings.sponsored_messages.min_sponsored_view_order,
                  {
                    min: digitsToHindi(
                      toMoneyFormat(String(min_sponsored_message_view))
                    ),
                  }
                )
          }
          placeholder={strings.sponsored_messages.view_count_placeholder}
          label={strings.sponsored_messages.view_count}
          className={styles.ViewInput}
          dir={viewCountInputHandler.rawValue ? "ltr" : "rtl"}
          data-testid="view-count-input"
        />
        <div className={styles.Divider}></div>
        <div className={styles.SectionHeader}>
          <p className={styles.SectionTitle}>
            {strings.sponsored_messages.tagsTitle}
          </p>
          {/* <Info
            size={20}
            color={theme.colors.dark[300]}
            cursor="pointer"
            onClick={() => setShowingHelperModal(HelperModals.TagsHelper)}
          /> */}
        </div>
        <p className={styles.TagsDescription}>
          {formatStrings(
            strings.dialog_ad_form.more_settings_step.tags.description,
            {
              value: strings.ad,
            }
          )}
        </p>
        <TagsDropdown
          onCategoryChange={onCategoryChange}
          onSubcategoryChange={onSubcategoryChange}
          categories={categories}
          subcategories={subcategories}
        />
        <TermsAndConditions
          checked={termsAccepted}
          onChange={handleChangeTerms}
        />
      </CardWrapper>
      <Footer>
        <Button
          onClick={submitHandler}
          text={strings.dialog_ad_form.info_step.submit}
          size={ButtonSize.XLarge}
          disable={isFormInvalid}
          data-testid="confirm-button"
        />
      </Footer>
      {!!showingHelperModal && (
        <Modal
          title={modalProperties.title!}
          primaryButton={{
            onClick: closeHelperModal,
            label: strings.common.button.understood,
          }}
          content={modalProperties.body}
          onClose={() => closeHelperModal()}
        />
      )}
    </>
  );
};

export default ViewOptions;
